import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ShieldCheck, X } from 'lucide-react';

/**
 * Primera vez: qué hace el botón, en tres frases. Portaleado al body y por encima del
 * sheet (`z-[100]`) y de los menús del visor (`z-[200]`).
 */
export const ModalExplicacion: React.FC<{
  onAnalizar: () => void;
  onCerrar: () => void;
}> = ({ onAnalizar, onCerrar }) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCerrar();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCerrar]);

  return createPortal(
    <div
      className="fixed inset-0 z-[250] flex items-center justify-center bg-black/40 p-4"
      onClick={onCerrar}
      role="dialog"
      aria-modal="true"
      aria-labelledby="verificacion-titulo"
    >
      <div className="w-full max-w-[420px] rounded-2xl bg-white p-6 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-4">
          {/* El fondo tenue va inline: `bg-brand-primary/10` no compila (Tailwind no resuelve
              opacidad sobre un color definido con var()). */}
          <span
            className="grid h-10 w-10 shrink-0 place-items-center rounded-xl text-brand-primary"
            style={{ backgroundColor: 'rgb(var(--brand-primary-rgb) / 0.10)' }}
          >
            <ShieldCheck className="h-5 w-5" />
          </span>
          <button
            type="button"
            aria-label="Cerrar"
            onClick={onCerrar}
            className="rounded-full p-1 text-neutral-400 transition-colors hover:text-brand-black"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <h2 id="verificacion-titulo" className="mt-4 text-lg font-semibold text-brand-black">
          Verificación de calidad
        </h2>
        <p className="mt-2 text-sm leading-relaxed text-neutral-600">
          Comparamos esta imagen con las fotos reales de tu producto —o, si no tiene producto, con lo que
          pediste y las referencias que usaste— y te decimos qué tan fiel salió: forma, color, logos,
          detalles. Es gratis y tarda unos segundos. Si algo no pasa, podés regenerar la imagen desde el
          mismo resultado.
        </p>
        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCerrar}
            className="rounded-xl py-2.5 px-5 text-sm font-medium text-brand-black transition-colors hover:bg-neutral-100"
          >
            Ahora no
          </button>
          <button
            type="button"
            onClick={onAnalizar}
            className="rounded-xl bg-brand-primary py-2.5 px-5 text-sm font-medium text-white transition-opacity hover:opacity-90"
          >
            Analizar esta imagen
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};
